import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

type ShippingWeight = {
  id?: string;
  clientForId: string | null;
  ranges: any[];
};
// type ShippingWeightUpdate = {
//   id?: string;
//   ranges: any[];
// };

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

export const useWeightCreateMutation = () => {
  return useMutation({
    mutationFn: async (payload: ShippingWeight) => {
      const res: ApiResponse = await fetch4(
        `${url}/api/shipping-weight`,
        payload
      );

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Staff Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ staff create request failed:", error.message);
    },
  });
};

export const useWeightMutation = (page: number, limit: number) => {
  return useQuery({
    queryKey: ["weightList", page, limit],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/shipping-weight?page=${page}&limit=${limit}`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

// PATCH mutation
export const useWeightUpdateMutation = () => {
  return useMutation({
    mutationFn: async ({
      id,
      payload,
    }: {
      id: string;
      payload: ShippingWeight;
    }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/shipping-weight/${id}`,
        "PATCH",
        payload
      );

      if (!res.success) {
        throw new Error(res.message || "Update failed");
      }

      return res.data;
    },
    onSuccess: () => {},
    onError: () => {},
  });
};

// apis/clientApis.ts
// export const useClientWeightListAllListData = (clientId?: string) => {
//   return useQuery({
//     queryKey: ["clientAllListWeightList", clientId],
//     queryFn: async () => {
//       if (!clientId) return null;

//       const res = await fetch3(
//         `${url}/api/shipping-weight/by-client/${clientId || ""}`,
//         "get"
//       );

//       if (!res || !res.data) {
//         throw new Error(res.message || "Failed to fetch client weight list");
//       }

//       return res.data;
//     },
//     enabled: !!clientId,
//   });
// };

export const useClientWeightListAllListData = (clientId?: string) => {
  return useQuery({
    queryKey: ["clientAllListWeightList", clientId || ""],
    queryFn: async () => {
      // if (!clientId) return null;

      const res = await fetch3(
        `${url}/api/shipping-weight/by-client/${clientId || ""}`,
        "get"
      );

      if (!res || !res.data) {
        throw new Error(res.message || "Failed to fetch client weight list");
      }

      return res.data;
    },
    enabled: !!clientId,
  });
};
